
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { Typography, Box, Button, TextField, LinearProgress,} from '@mui/material';
import { Menu as MainMenu } from '../../components/Menu';

import { getConsolidations } from '../../api/сonsolidations';
import { useData } from '../../hooks/DataProvider';

import { DataGrid } from '@mui/x-data-grid';

import translations from '../../scripts/translations';

import { ModelConsolidation } from '../../models/ModelConsolidation';
import { ShipmentDirections, } from '../../scripts/configData';



const Consolidations = () => {

    const { updateDataShipement, language } = useData();
    const btns = translations.button[language];
    const page = translations.pages.consolidations[language];

    const navigate = useNavigate();

    const [consolidations, setConsolidations] = useState([]);

    const [consolidationsFilter, setConsolidationsFilter] = useState({});
    const [loading, setLoading] = useState(false);

    const getLocalFilter = async () => {
        const localFilter = localStorage.getItem('consolidationsFilter');
        return localFilter ? JSON.parse(localFilter) : {};
    };

    const setLocalFilter = (filter) => {
        localStorage.setItem('consolidationsFilter', JSON.stringify(filter));
    };


    const updateConsolidationsFilter = (newFilter) => {
        let currentFilter = {}
        if (newFilter.value === '') {
            currentFilter = { ...consolidationsFilter };
            delete currentFilter[newFilter.field];
            setConsolidationsFilter(currentFilter)
        }
        else {
            currentFilter = { ...consolidationsFilter, [newFilter.field]: newFilter.value }
        }
        setConsolidationsFilter(currentFilter)
        setLocalFilter(currentFilter);

    }

    const clearConsolidationsFilter = () => {
        setConsolidationsFilter({});
        setLocalFilter({});
        fetchConsolidations({});
    };



    const fetchConsolidations = async (filter) => {
        try {
            setLoading(true);
            let startTime = new Date().getTime();
            const response = await getConsolidations(filter);
            setConsolidations(response);

            console.log('Consolidations fetched successfully:', response);
            let endTime = new Date().getTime();
            console.log(`Fetch Consolidations took ${endTime - startTime} ms`);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching consolidations:', error);
        }
    };

    useEffect(() => {

        const fetchConsolidationsFromLocalStorage = async () => {
            const filters = await getLocalFilter();
            if (filters) {
                setConsolidationsFilter(filters);
                fetchConsolidations(filters);
            } else {
                setConsolidationsFilter({});
                fetchConsolidations({});
            }
        };  
        fetchConsolidationsFromLocalStorage();

    }, []);


    const handleShipementUpdate = (item) => {
        updateDataShipement(item);
        navigate(`/consolidations/${item._id}`);

    };


    const columnsConsolidations = [
        { field: 'consolidationCode', headerName: ModelConsolidation.consolidationCode[language], width: 110 },
        {
            field: 'departureDate',
            headerName: ModelConsolidation.departureDate[language],
            width: 120,
            editable: false,
            valueGetter: (value, row) => dayjs(row.departureDate).isValid() ? dayjs(row.departureDate).format('DD/MM/YYYY') : ''
        },
        {
            field: 'shipmentDirection',
            headerName: ModelConsolidation.shipmentDirection[language],
            width: 100,
            editable: true,
            valueGetter: (value, row) => ShipmentDirections.filter(item => item.key === row.shipmentDirection)[0]?.[language] || ''
        },

        {
            field: 'consignor',
            headerName: ModelConsolidation.consignor[language],
            width: 200,
            editable: false,
            valueGetter: (value, row) => `${row.consignor?.name || ''}`
        },
        {
            field: 'consignee',
            headerName: ModelConsolidation.consignee[language],
            width: 200,
            editable: false,
            valueGetter: (value, row) => `${row.consignee?.name || ''}`
        },
        {
            field: 'internalRef',
            headerName: ModelConsolidation.internalRef[language],
            width: 120,
            editable: false,
            valueGetter: (value, row) => `${row?.internalRef || ''}`
        },
        {
            field: 'customerRef',
            headerName: ModelConsolidation.customerRef[language],
            width: 120,
            editable: false,
            valueGetter: (value, row) => `${row?.customerRef || ''}`
        },
        {
            field: 'totalHU',
            headerName: page.hu,
            width: 100,
            editable: false,
            // valueGetter: (value, row) => `${row?.total_hu || ''}`
        },
        {
            field: 'totalWeight',
            headerName: page.weight,
            width: 80,
            editable: false,
            // valueGetter: (value, row) => `${row?.total_weight || ''}`
        },
        {
            field: 'totalVolume',
            headerName: page.volume,
            width: 80,
            editable: false,
            // valueGetter: (value, row) => `${row?.total_volume || ''}`
        },


            // totalHU
            // totalVolume
            // totalWeight
            // total_chargeable_weight


        // {
        //     field: 'origin',
        //     headerName: ModelConsolidation.origin[language],
        //     width: 200,
        //     editable: false,
        //     valueGetter: (value, row) => `${row.origin?.name || ''}`
        // },
        // {
        //     field: 'destination',
        //     headerName: ModelConsolidation.destination[language],
        //     width: 200,
        //     editable: false,
        //     valueGetter: (value, row) => `${row.consignee?.destination || ''}`
        // },

    ];


    const TextFieldProps = {
        variant: 'outlined',
        size: 'small',
        sx: { width: '100%' },
        InputLabelProps: {
            shrink: true,
        },
        autoComplete: "off"
    }

    return (
        <>
            <MainMenu currentPage={'consolidations'} />

            <Box sx={{ mb: 0, py: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='overline' component='h1' sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {page.title}
                </Typography>

                <Link to={`/consolidations/new`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button variant='outlined' >{btns.add}</Button>
                </Link>
            </Box>

            {/* search barre  */}
            <Box sx={{ mb: 2, py: 2, display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>

                <TextField
                    label={ModelConsolidation.consolidationCode[language]}
                    value={consolidationsFilter.consolidationCode || ''}
                    onChange={(e) => updateConsolidationsFilter({ field: 'consolidationCode', value: e.target.value })}
                    {...TextFieldProps}
                />

                <TextField
                    label={ModelConsolidation.consignor[language]}
                    value={consolidationsFilter.consignor || ''}
                    onChange={(e) => updateConsolidationsFilter({ field: 'consignor', value: e.target.value })}
                    {...TextFieldProps}
                />
                <TextField
                    label={ModelConsolidation.consignee[language]}
                    value={consolidationsFilter.consignee || ''}
                    onChange={(e) => updateConsolidationsFilter({ field: 'consignee', value: e.target.value })}
                    {...TextFieldProps}
                />
                <TextField
                    label={ModelConsolidation.origin[language]}
                    value={consolidationsFilter.origin || ''}
                    onChange={(e) => updateConsolidationsFilter({ field: 'origin', value: e.target.value })}
                    {...TextFieldProps}
                />
                <TextField
                    label={ModelConsolidation.destination[language]}
                    value={consolidationsFilter.destination || ''}
                    onChange={(e) => updateConsolidationsFilter({ field: 'destination', value: e.target.value })}
                    {...TextFieldProps}
                />





                <Box sx={{ display: 'flex', gap: 1 }}>

                    <Button variant='outlined' onClick={clearConsolidationsFilter} >{btns.clear}</Button>
                    <Button variant='outlined' onClick={() => {
                        console.log(consolidationsFilter)
                        fetchConsolidations(consolidationsFilter)
                    }} >{btns.search}</Button>
                </Box>




            </Box>



            {loading && <LinearProgress sx={{ mb: 2 }} />}

            {!loading && <Box sx={{ height: 520, width: '100%' }}>
                <Box sx={{ width: '100%' }}>
                    <DataGrid
                        rows={consolidations}
                        getRowId={(row) => row._id}
                        columns={columnsConsolidations}

                        showToolbar={true}
                        slotProps={{
                            toolbar: {
                                printOptions: { disableToolbarButton: true },
                            },
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[25]}
                        // checkboxSelection
                        disableRowSelectionOnClick
                        columnVisibilityModel={{
                           shipmentDirection: false, // Hide shipmentDirection column by default
                        }}
                        onRowClick={(params) => handleShipementUpdate(params.row)}
                        sx={{
                            '& .MuiDataGrid-row:hover': {
                                cursor: 'pointer',
                            },
                            '& .MuiDataGrid-cell:focus': {
                                outline: 'none',
                            },
                            fontSize: '0.8rem',
                        }}
                    />
                </Box>
            </Box>
            }


        </>
    );
}

export default Consolidations;
